import React from 'react';
import './index.scss';

const Modal = ({ title, children, fast = false }) => {
  return (
    <>
      <div className='overlay'></div>
      <dialog className={`modal ${fast ? 'modal--fast' : ''}`}>
        <span className='modal__intro'>{title}</span>
        <div className='modal__container'>{children}</div>
      </dialog>
    </>
  );
};

export default Modal;
